'use client';

import { useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import axios from '@/lib/axios';
import { isAxiosError } from 'axios';
import FlashSale from '@/features/flash-sale/flash-sale/components/FlashSale';
import FlashSaleProduct from '@/features/flash-sale/flash-sale-product/components/FlashSaleProduct';
import Preloader from '@/features/preloader/components/Preloader';
import { API_GIGALOGY_SEARCH } from '@/constant/apiRout';

const FlashSaleContent = () => {
  // Now it's safe to use the hook here
  const searchParams = useSearchParams();
  const page = searchParams.get('page');

  const [products, setProducts] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const res = await axios.post(
          API_GIGALOGY_SEARCH,
          {
            page: Number(page) || 1,
            order_by: 'hot',
          },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );
        setProducts(res.data);
      } catch (error) {
        // You should handle the error, e.g., show an error message
        console.error('Failed to fetch products', error);
        if (isAxiosError(error)) {
          // Or set an error state to show in the UI
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
    // The 'page' variable is a dependency derived from searchParams
  }, [page]);

  return (
    <>
      {products?.data?.length > 0 && (
        <FlashSale dateTimer={products?.data?.[0]?.hot_deals_end_datetime} />
      )}
      <FlashSaleProduct flashSales={products} loading={loading} />
    </>
  );
};

export default FlashSaleContent;
